/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */

export const GenericUrlErrorTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.GenericUrlError';
export const InvalidFormatTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidFormat';
export const InvalidLengthTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidLength';
export const InvalidReservationExtensionTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.InvalidReservationExtension';
export const PortalIdMismatchTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.PortalIdMismatch';
export const ScreenshotNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.ScreenshotNotFound';
export const SiteNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.SiteNotFound';
export const UnexpectedRegexTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UnexpectedRegex';
export const UrlAlreadyRegisteredTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyRegistered';
export const UrlAlreadyReservedTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlAlreadyReserved';
export const UrlInUseTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlInUse';
export const UrlNotFoundTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotFound';
export const UrlNotReservedTypename = 'com.hubspot.marketplace.urls.models.rpcs.errors.UrlNotReserved';
export const getScreenshotRpc = {
  serviceName: 'com.hubspot.marketplace.urls.rpc.ScreenshotRpc',
  rpcName: 'getScreenshot',
  auth: 'external',
  fingerprint: 'yMEF2-kjD01cmmMEGroNLwTPIEIL4xPp',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};